/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateTransmittalDocument,
  PagedResultOfTransmittalDocumentFileInfoDto,
  TransmittalDocumentDto,
  TransmittalDocumentFileContentDto,
  TransmittalDocumentFileInfoDto,
  UploadFileTransmittalDocumentsBody
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Creates a new transmittal document.
 */
export const createTransmittalDocument = (
    createTransmittalDocument: CreateTransmittalDocument,
 options?: SecondParameter<typeof customInstance<TransmittalDocumentDto>>,) => {
      return customInstance<TransmittalDocumentDto>(
      {url: `/transmittal/transmittal-documents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTransmittalDocument
    },
      options);
    }
  /**
 * @summary Deletes the transmittal document identified by the route id.
 */
export const deleteTransmittalDocument = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/transmittal/transmittal-documents/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Uploads a file associated with the transmittal document identified by the route document Id.
 */
export const uploadFileTransmittalDocuments = (
    id: string,
    uploadFileTransmittalDocumentsBody: UploadFileTransmittalDocumentsBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {const formData = new FormData();
if(uploadFileTransmittalDocumentsBody.file !== undefined) {
 formData.append(`file`, uploadFileTransmittalDocumentsBody.file);
 }

      return customInstance<void>(
      {url: `/transmittal/transmittal-documents/${id}/files`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  /**
 * @summary Gets the list of files associated with the transmittal document identified by the route documentId.
 */
export const getTransmittalDocumentFiles = (
    id: string,
 options?: SecondParameter<typeof customInstance<PagedResultOfTransmittalDocumentFileInfoDto>>,) => {
      return customInstance<PagedResultOfTransmittalDocumentFileInfoDto>(
      {url: `/transmittal/transmittal-documents/${id}/files`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Gets the file associated with the transmittal document identified by the route documentId and fileId.
 */
export const getTransmittalDocumentFileInfo = (
    id: string,
    fileId: string,
 options?: SecondParameter<typeof customInstance<TransmittalDocumentFileInfoDto>>,) => {
      return customInstance<TransmittalDocumentFileInfoDto>(
      {url: `/transmittal/transmittal-documents/${id}/files/${fileId}/info`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Downloads the file content associated with the transmittal document identified by the route
 */
export const downloadTransmittalDocumentFile = (
    id: string,
    fileId: string,
 options?: SecondParameter<typeof customInstance<TransmittalDocumentFileContentDto>>,) => {
      return customInstance<TransmittalDocumentFileContentDto>(
      {url: `/transmittal/transmittal-documents/${id}/files/${fileId}/content`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Deletes the file associated with the transmittal document identified by the route documentId and fileId.
 */
export const deleteTransmittalDocumentFile = (
    id: string,
    fileId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/transmittal/transmittal-documents/${id}/files/${fileId}`, method: 'DELETE'
    },
      options);
    }
  export type CreateTransmittalDocumentResult = NonNullable<Awaited<ReturnType<typeof createTransmittalDocument>>>
export type DeleteTransmittalDocumentResult = NonNullable<Awaited<ReturnType<typeof deleteTransmittalDocument>>>
export type UploadFileTransmittalDocumentsResult = NonNullable<Awaited<ReturnType<typeof uploadFileTransmittalDocuments>>>
export type GetTransmittalDocumentFilesResult = NonNullable<Awaited<ReturnType<typeof getTransmittalDocumentFiles>>>
export type GetTransmittalDocumentFileInfoResult = NonNullable<Awaited<ReturnType<typeof getTransmittalDocumentFileInfo>>>
export type DownloadTransmittalDocumentFileResult = NonNullable<Awaited<ReturnType<typeof downloadTransmittalDocumentFile>>>
export type DeleteTransmittalDocumentFileResult = NonNullable<Awaited<ReturnType<typeof deleteTransmittalDocumentFile>>>
